import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { VIEW_MODE } from '@/common/define/common.define';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { requireDomainTargetOrTutorial } from '@/common/router/authGuard';
import { RouteRecordRaw } from 'vue-router';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_MESSAGE_QUEUE = 'message-queue_';

const messageQueueMenu: RouteRecordRaw[] = [
  {
    path: '/message-queue/',
    name: `${PREFIX_MESSAGE_QUEUE}Message-Queue`,
    component: BaseViewport,
    beforeEnter: [
      requireAuth,
      () => requireDomainTargetOrTutorial('message-queue'),
      setDayjsTimezone,
    ],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_MESSAGEQUEUE,
      invisibleViewMode: [VIEW_MODE.MAXGAUGE],
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'kafka',
        name: `${PREFIX_MESSAGE_QUEUE}Kafka`,
        component: () => import('@/messageQueue/views/kafka/KafkaView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_MESSAGEQUEUE_KAFKA,
          invisibleViewMode: [VIEW_MODE.MAXGAUGE],
        },
      },
    ],
  },
];

const getMessageQueueMenu = (): RouteRecordRaw[] => {
  const filteredMessageQueueMenu = extractAccessibleRoutes(messageQueueMenu);

  return [...filteredMessageQueueMenu];
};

export { messageQueueMenu, getMessageQueueMenu };
